module.exports = __webpack_public_path__ + "static/vital-1-00cdea5c62d6c824fcfe1d3ea8f5d252.jpg";